import script from "./AnswersPagesOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./AnswersPagesOverview.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__